module.exports = (s) => {
  return {
    landing_type: {
      label: '推广目的',
      type: 'select',
      options: s.$store.getters.jrttEnum.api_2_landing_type,
      value: [],
    },
    app_promotion_type: {
      label: '子推广目的',
      type: 'select',
      options: s.$store.getters.jrttEnum.api_2_app_promotion_type,
      value: '',
    },
    marketing_goal: {
      label: '营销场景',
      type: 'select',
      options: s.$store.getters.jrttEnum.api_2_marketing_goal,
      value: '',
    },
    ad_type: {
      label: '广告类型',
      type: 'select',
      options: s.$store.getters.jrttEnum.api_2_ad_type,
      value: '',
    },
    inventory_type: {
      label: '首选位置',
      type: 'select',
      options: s.$store.getters.jrttEnum.ad_inventory_type,
      value: '',
    },
    platform: {
      label: '对应平台',
      type: 'select',
      options: s.$store.getters.jrttEnum.api_2_platforms,
      value: '',
    },
    create_time: {
      label: '创建时间',
      type: 'date-picker',
      value: '',
      props: {
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd',
        rangeSeparator: '至',
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
      },
    },
    update_time: {
      label: '最后更新时间',
      type: 'date-picker',
      value: '',
      props: {
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd',
        rangeSeparator: '至',
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
      },
    },
  };
};

